<template>
  <div>
    <h6 style="color: #101010;">
      {{ $l('INDEX.form_header_booking') || '订舱信息' }}
    </h6>
    <el-descriptions
      border
      :column="3"
      size="small"
      class="border-bottom-none"
      :labelStyle="{ width: '120px' }"
      :contentStyle="{ width: '190px' }"
    >
      <el-descriptions-item :label="$l('INDEX.form_bookingType') || '订舱类型'">
        {{ booking.v_bookingType }}
      </el-descriptions-item>
      <el-descriptions-item
        :label="$l('INDEX.form_label_plannedETD') || '计划发运日期'"
      >
        {{ booking.plannedETD }}
      </el-descriptions-item>
      <el-descriptions-item
        :label="$l('INDEX.form_quotedMethod') || '报价方式'"
      >
        {{ booking.v_quotedMethod }}
      </el-descriptions-item>
      <el-descriptions-item
        :label="$l('INDEX.form_shipmentType') || '发运方式'"
      >
        {{ booking.v_shipmentType }}
      </el-descriptions-item>
      <el-descriptions-item
        :label="$l('INDEX.table_label_destinationPort') || '目的港口'"
      >
        {{ booking.v_destinationPort }}
      </el-descriptions-item>
      <el-descriptions-item
        :label="$l('INDEX.form_label_destinationPortFullName') || '指运港'"
      >
        {{ booking.destinationPortFullName }}
      </el-descriptions-item>
      <el-descriptions-item
        :label="$l('INDEX.form_destinationCountry') || '目的国'"
      >
        {{ booking.destinationCountry }}
      </el-descriptions-item>
      <el-descriptions-item :label="$l('INDEX.form_vessel') || '船名'">
        {{ booking.vessel }}
      </el-descriptions-item>
      <el-descriptions-item :label="$l('INDEX.form_voyage') || '航次'">
        {{ booking.voyage }}
      </el-descriptions-item>
      <el-descriptions-item
        :label="$l('INDEX.form_label_bookingDate') || '订舱日期'"
      >
        {{ booking.bookingDate }}
      </el-descriptions-item>
      <el-descriptions-item
        :label="$l('INDEX.form_deliveryDate') || '产装日期'"
      >
        {{ booking.deliveryDate }}
      </el-descriptions-item>
      <el-descriptions-item :label="$l('INDEX.form_closingDate') || '开船日期'">
        {{ booking.closingDate }}
      </el-descriptions-item>
      <el-descriptions-item
        :label="$l('INDEX.form_label_eta') || '进仓/到港日期'"
      >
        {{ booking.eta }}
      </el-descriptions-item>
      <el-descriptions-item
        :label="$l('INDEX.form_label_cfdDate') || '提交清关文件日期'"
      >
        {{ booking.cfdDate }}
      </el-descriptions-item>
      <el-descriptions-item
        :label="$l('INDEX.form_label_pfdDate') || '提交付款文件日期'"
      >
        {{ booking.pfdDate }}
      </el-descriptions-item>
    </el-descriptions>

    <el-descriptions
      :column="2"
      size="small"
      border
      :labelStyle="{ width: '120px' }"
      :contentStyle="{ width: '345px' }"
    >
      <el-descriptions-item
        :label="$l('INDEX.form_domesticShipperCode') || '境内发货人'"
      >
        {{ booking.domesticShipperName }}
      </el-descriptions-item>
      <el-descriptions-item
        :label="$l('INDEX.form_overseasConsigneeCode') || '境外收货人'"
      >
        {{ booking.overseasConsigneeName }}
      </el-descriptions-item>
      <el-descriptions-item :label="$l('INDEX.form_shipper') || '发货人'">
        {{ booking.v_shipperCode }}
      </el-descriptions-item>
      <el-descriptions-item :label="$l('INDEX.form_consignee') || '收货人'">
        {{ booking.v_consigneeCode }}
      </el-descriptions-item>
      <el-descriptions-item :label="$l('INDEX.form_notifier') || '通知人'">
        {{ booking.v_notifierCode }}
      </el-descriptions-item>
      <el-descriptions-item :label="$l('INDEX.form_bookingScm') || '订舱货代'">
        {{ booking.bookingScmName }}
      </el-descriptions-item>
      <el-descriptions-item
        :label="$l('INDEX.form_customsBrokerScmCode') || '报关货代'"
      >
        {{ booking.customsBrokerScmName }}
      </el-descriptions-item>
      <el-descriptions-item :label="$l('INDEX.form_transitScm') || '运输公司'">
        {{ booking.transitScmName }}
      </el-descriptions-item>
    </el-descriptions>

    <h6 style="color: #101010;" class="mt-4">
      {{ $l('INDEX.form_header_container') || '货柜明细' }}
    </h6>
    <BookingContainer
      :shipmentCode="shipmentCode"
      :shipmentBookingCode="shipmentBookingCode"
    />

    <h6 style="color: #101010;" class="mt-4">
      {{ $l('INDEX.form_header_containerPo') || '装柜PO' }}
    </h6>
    <BookingContainerPo
      :shipmentCode="shipmentCode"
      :shipmentBookingCode="shipmentBookingCode"
    />
  </div>
</template>

<script>
import BookingContainer from './components/booking-container'
import BookingContainerPo from './components/booking-container-po'
export default {
  components: { BookingContainer, BookingContainerPo },
  props: {
    shipmentCode: { type: String, default: '' },
    shipmentBookingCode: { type: String, default: '' },
  },
  data() {
    return { booking: {}, loading: false }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      this.loading = true
      const res = await this.$api
        .shipmentBookingDetailApi({
          shipmentBookingCode: this.shipmentBookingCode,
        })
        .catch(() => null)
      this.loading = false
      if (!res) return
      this.booking = res.body || {}
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .el-descriptions.border-bottom-none {
    .el-descriptions-item__label,
    .el-descriptions-item__content {
      border-bottom: none !important;
    }
  }
}
</style>
